<template>
    <div class="sidebar">

        <sample />

        <ul class="control">
            <button 
                @click="$emit('start')"
                >
                {{ ( gameOver || gameWin || isPlaying ) ? '重玩' : '开始扫雷' }}
            </button>
             <button 
                class="stop"
                v-show="isPlaying"
                @click="$emit('over')"
                >
                {{ '不玩了' }}
            </button>
        </ul>
    </div>
</template>

<script>
import sample from './sample'

export default {
    name: 'Sidebar',
    computed: {
        isPlaying () {
            return this.$store.state.isPlaying
        },
        gameOver () {
            return this.$store.state.gameOver
        },
        gameWin () {
            return this.$store.state.gameWin
        }
    },
    components: {
        sample
    }
}
</script>

<style lang="scss" scoped>

$color: rgb(160, 192, 226);
$stopColor: rgb(240, 151, 185);
$backgroundColor: rgb(238, 234, 214);

.sidebar {
    width: 240px;
    display: flex;
    flex-direction: column;
    padding: 25px 25px 0;
    border: 5px solid rgb(94, 94, 94);
    background-color: $backgroundColor;
    border-radius: 12px;
    box-sizing: border-box;

    .control {
        margin-top: 15px;
        padding: 15px 0;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        border-top: 2px dashed darken($backgroundColor, 15%);

            button {
                padding: 14px 0;
                margin-bottom:15px;
                width: 90%;
                background-color: darken($color, 10%);
                border: 4px solid darken($color, 20%);
                color: #fff;
                border-radius: 5px;
                cursor: pointer;
                user-select: none;
                font-size:1.1rem;

                &.stop {
                    padding: 4px 0;
                    background-color: darken($stopColor, 10%);
                    border: 4px solid darken($stopColor, 20%);
                    color: #fff;
                    font-size:.9rem;
                }

                &:active {
                    box-shadow: 0 5px 5px rgba(0,0,0,.15) inset;
                }
            }
    }

}
</style>